import styled from "styled-components";

export const ProductsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .titleText {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.5;
    color: #460259;
    padding-top: 2rem;
    padding-bottom: 1rem;

    span {
      font-size: 0.75rem;
      margin-left: 0.75rem;
      color: #6bbfbf;
      font-weight: 300;
    }
  }

  .banner {
    max-width: 100%;
  }

  .bannerSecundary {
    max-width: 100%;
    padding: 2rem 0;
  }

  @media (max-width: 1200px) {
    align-items: center;
  }
`;
